import { of } from 'rxjs';
import { publishLast } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';

import { Session } from './session';
import { ServerApi } from './server-api';

import { inDemoMode, inReadOnlyMode, inSupportMode } from '@app/lib/remote-login';

@Injectable({ providedIn: 'root' })
export class DashboardSettings {
  protected _settings: any = {};

  constructor(
    @Inject(Session) private session,
    @Inject(ServerApi) private api,
  ) {
    this._initSettings();
  }

  public getKey(key) { return this._settings[key]; }

  public setKey(key, val) {
    const settings = this._settings;
    if (this._settings[key] !== val) {
      this._settings[key] = val;
      return this._save(settings);
    } else return of(null);
  }

  private _initSettings() {
    let settings = this.session.getUser().dashboard_settings;
    try {
      settings = settings ? JSON.parse(settings) : {};
    } catch (e) {
      settings = {};
    }
    this._settings = settings;
  }

  private _save(settings) {
    // When in remote_login session prevent displaying excessive alerts upon loading dashboard
    if (inDemoMode() || inSupportMode() || inReadOnlyMode()) return;

    const userId = this.session.getUserId();
    const data = { dashboard_settings: JSON.stringify(settings) };
    const observable = this.api.put(`users/${userId}`, data).pipe(publishLast());
    observable.connect();
    return observable;
  }

}
